import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
// import ExcelApi from "../../../api/excel.api";
import "react-date-range/dist/styles.css"; // 기본 스타일 파일
import "react-date-range/dist/theme/default.css"; // 테마 css 파일
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import PretendardText from "../../../component/atoms/text/pretendardText";
import TableTitle from "../../../component/atoms/text/table/tableTitle";
import TableTab02 from "../../../component/molecules/tableTab02";
import Modal from "../../../component/templates/Modal";
import { route } from "../../../router/route";
import { isNull } from "../../../util/check";
import { errorHandler } from "../../../util/errorHandler";
import { modalMsg } from "../../../util/modalMsg";
import { toastMsg } from "../../../util/toastMsg";
import SaveBtn from "./../../../component/atoms/button/saveBtn";
import DateInput from "./../../../component/atoms/input/dateInput";
import MainInput from "./../../../component/atoms/input/mainInput";
import Radio from "./../../../component/atoms/input/radio";
import DetailPageForm from "./../../../component/atoms/layout/detail/detailPageForm";
import DetailPageLayout from "./../../../component/atoms/layout/detail/detailPageLayout";
import MainLayout from "./../../../component/atoms/layout/mainLayout";
import DetailFormText from "./../../../component/atoms/text/detail/detailFormText";
import DetailFormTitle from "./../../../component/atoms/text/detail/detailFormTitle";
import DetailPageTitle from "./../../../component/atoms/text/detail/detailPageTitle";
import Header from "./../../../component/organisms/header";
import Sidebar from "./../../../component/organisms/sidebar";
import CouponApi from "../../../api/coupon.api";
import MemberApi from "../../../api/memebr.api";
import Checkbox from "../../../component/atoms/input/checkbox";
import SearchBar from "../../../component/atoms/input/searchBar";
import Table from "../../../component/atoms/layout/table/table";
import TableSearchBtn from "../../../component/atoms/layout/table/tableSearchBtn";
import TableTop from "../../../component/atoms/layout/table/tableTop";
import Td from "../../../component/atoms/layout/table/td";
import Th from "../../../component/atoms/layout/table/th";
import Tr from "../../../component/atoms/layout/table/tr";
import TableText from "../../../component/atoms/text/table/tableText";
import Pagination from "../../../component/molecules/pagination";
import TableCount2 from "../../../component/molecules/tableCount2";

const CouponIssuance = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const initialPublicationData = {
    title: "",
    couponType: "PRICE",
    amount: 0,
    startDate: new Date(),
    endDate: new Date(),
  };

  const [couponData, setCouponData] = useState(initialPublicationData);
  const [memberList, setMemberList] = useState([]);
  const [selectedMemberIds, setSelectedMemberIds] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [pagination, setPagination] = useState({
    size: 10,
    rangeSize: 5,
    totalCount: 0,
    totalPages: 0,
  });
  const page = Number(searchParams.get("page") || 1);

  useEffect(() => {
    setKeyword(searchParams.get("keyword") || "");
    getMemberList();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  const getMemberList = async () => {
    try {
      const response = (
        await MemberApi.getList({
          keyword: searchParams.get("keyword") || undefined,
          page,
          size: pagination.size,
        })
      ).data.data;

      setMemberList(response.content ?? []);
      setPagination((current) => ({
        ...current,
        totalCount: response.totalCount ?? 0,
        totalPages: Math.ceil((response.totalCount ?? 0) / current.size),
      }));
    } catch (error) {
      errorHandler(error);
    }
  };

  const isAllPageSelected = useMemo(
    () =>
      memberList.length > 0 &&
      memberList.every((member) => selectedMemberIds.includes(member.id)),
    [memberList, selectedMemberIds],
  );

  const toggleMember = (memberId) => {
    setSelectedMemberIds((current) =>
      current.includes(memberId)
        ? current.filter((id) => id !== memberId)
        : [...current, memberId],
    );
  };

  const toggleCurrentPage = (checked) => {
    const pageIds = memberList.map((member) => member.id);
    setSelectedMemberIds((current) =>
      checked
        ? [...new Set([...current, ...pageIds])]
        : current.filter((id) => !pageIds.includes(id)),
    );
  };

  //저장하기
  const [saveModalOpen, setSaveModalOpen] = useState(false);

  const saveBtnHandler = () => {
    const amount = Number(couponData.amount);
    const startDate = moment(couponData.startDate);
    const endDate = moment(couponData.endDate);

    if (
      isNull(couponData.title?.trim()) ||
      isNull(couponData.startDate) ||
      isNull(couponData.endDate)
    ) {
      return toast(`필수 요소를 전부 입력해주세요.`);
    }

    if (!Number.isFinite(amount) || amount <= 0) {
      return toast("할인 금액은 0보다 크게 입력해주세요.");
    }

    if (couponData.couponType === "RATIO" && amount > 100) {
      return toast("할인율은 100%를 넘을 수 없습니다.");
    }

    if (
      !startDate.isValid() ||
      !endDate.isValid() ||
      startDate.isAfter(endDate, "day")
    ) {
      return toast("사용 기간을 올바르게 선택해주세요.");
    }

    if (selectedMemberIds.length === 0) {
      return toast("쿠폰을 발급할 회원을 선택해주세요.");
    }

    setSaveModalOpen(true);
  };

  const saveFunc = async () => {
    try {
      const data = {
        couponType: couponData.couponType,
        title: couponData.title.trim(),
        amount: Number(couponData.amount),
        startDate: moment(couponData.startDate).startOf("day").toISOString(),
        endDate: moment(couponData.endDate).endOf("day").toISOString(),
        memberIds: selectedMemberIds,
      };

      await CouponApi.create(data);
      setSaveModalOpen(false);
      setCouponData(initialPublicationData);
      setSelectedMemberIds([]);
      toast(toastMsg.create);
    } catch (error) {
      if (error.response?.status === 400) {
        return toast(`${error.response.data.message}`);
      }
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <TableTitle style={{ marginBottom: "20px" }}>
            {"쿠폰 관리"}
          </TableTitle>
          <TableTab02
            list={[
              {
                title: `쿠폰 발급`,
                link: route.payment_coupon_issuance,
                originLink: route.payment_coupon_issuance,
              },
              {
                title: `발급 내역`,
                link: route.payment_coupon_history,
                originLink: `${route.payment_coupon_history}`,
              },
            ]}
            style={{ marginBottom: "20px" }}
          />
          <DetailPage>
            <DetailPageTitle>{"발행하기"}</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              {/* 쿠폰명 */}
              <DetailPageForm>
                <DetailFormTitle>{"쿠폰명*"}</DetailFormTitle>
                <MainInput
                  style={{
                    width: 338,
                  }}
                  type={"text"}
                  placeholder={"쿠폰명을 입력해 주세요."}
                  value={couponData.title}
                  onChange={(e) =>
                    setCouponData({
                      ...couponData,
                      title: e.target.value,
                    })
                  }
                />
              </DetailPageForm>

              {/* 유형 */}
              <DetailPageForm>
                <DetailFormTitle>{"유형*"}</DetailFormTitle>
                <DetailFormText>
                  <div style={{ display: "flex", gap: "20px" }}>
                    <Radio
                      id={"PRICE"}
                      valueText={"금액 할인"}
                      checked={couponData.couponType == "PRICE"}
                      onChange={() => {
                        setCouponData({
                          ...couponData,
                          couponType: "PRICE",
                        });
                      }}
                    />
                    <Radio
                      id={"RATIO"}
                      valueText={"%할인"}
                      checked={couponData.couponType == "RATIO"}
                      onChange={() => {
                        setCouponData({
                          ...couponData,
                          couponType: "RATIO",
                        });
                      }}
                    />
                  </div>
                </DetailFormText>
              </DetailPageForm>

              {/* 할인금액 */}
              {couponData.couponType !== "DELIVERY" ? (
                <DetailPageForm>
                  <DetailFormTitle>{"할인금액*"}</DetailFormTitle>
                  <MainInput
                    type={"number"}
                    style={{
                      width: 338,
                    }}
                    placeholder={"금액 또는 %를 입력해 주세요."}
                    value={couponData.amount}
                    onChange={(e) => {
                      if (
                        couponData.couponType === "RATIO" &&
                        e.target.value > 100
                      ) {
                        return;
                      }
                      setCouponData({
                        ...couponData,
                        amount: e.target.value,
                      });
                    }}
                  />
                </DetailPageForm>
              ) : null}

              {/* 사용기간 */}
              <DetailPageForm>
                <DetailFormTitle>{"사용기간*"}</DetailFormTitle>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <DateInput
                    value={couponData.startDate}
                    onChange={(e) => {
                      const selectedDate = new Date(e.target.value);
                      const today = new Date();

                      selectedDate.setHours(0, 0, 0, 0);
                      today.setHours(0, 0, 0, 0);

                      if (selectedDate < today) {
                        alert("선택한 날짜는 오늘보다 이전일 수 없습니다.");
                      } else {
                        setCouponData({
                          ...couponData,
                          startDate: e.target.value,
                        });
                      }
                    }}
                  />
                  <div
                    style={{
                      width: "6px",
                      height: "1px",
                      backgroundColor: "#262c31",
                      borderRadius: 6,
                    }}
                  />
                  <DateInput
                    value={couponData.endDate}
                    onChange={(e) => {
                      const selectedDate = new Date(e.target.value);
                      const today = new Date();

                      selectedDate.setHours(0, 0, 0, 0);
                      today.setHours(0, 0, 0, 0);

                      if (selectedDate < today) {
                        alert("선택한 날짜는 오늘보다 이전일 수 없습니다.");
                      } else {
                        setCouponData({
                          ...couponData,
                          endDate: e.target.value,
                        });
                      }
                    }}
                  />
                </div>
              </DetailPageForm>
            </div>
          </DetailPage>
          <DetailPage style={{ marginTop: "20px" }}>
            <DetailPageTitle>발급 대상 회원*</DetailPageTitle>
            <TableTop style={{ width: "100%", marginBottom: "12px" }}>
              <TableCount2
                text={`선택 ${selectedMemberIds.length}명 / 전체`}
                count={pagination.totalCount}
              />
              <TableSearchBtn>
                <SearchBar
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      navigate(
                        `${route.payment_coupon_issuance}?page=1&keyword=${encodeURIComponent(keyword.trim())}`,
                        { replace: true },
                      );
                    }
                  }}
                  onClick={() =>
                    navigate(
                      `${route.payment_coupon_issuance}?page=1&keyword=${encodeURIComponent(keyword.trim())}`,
                      { replace: true },
                    )
                  }
                />
              </TableSearchBtn>
            </TableTop>
            <Table style={{ width: "100%", tableLayout: "fixed" }}>
              <colgroup>
                <col style={{ width: "7%" }} />
                <col style={{ width: "32%" }} />
                <col style={{ width: "25%" }} />
                <col style={{ width: "18%" }} />
                <col style={{ width: "18%" }} />
              </colgroup>
              <thead>
                <Tr style={{ height: "40px", background: "#f2f4f5" }}>
                  <Th style={{ paddingLeft: "20px" }}>
                    <Checkbox
                      checked={isAllPageSelected}
                      onChange={(e) => toggleCurrentPage(e.target.checked)}
                    />
                  </Th>
                  <Th>
                    <TableText>아이디</TableText>
                  </Th>
                  <Th>
                    <TableText>이름</TableText>
                  </Th>
                  <Th>
                    <TableText>회원 유형</TableText>
                  </Th>
                  <Th>
                    <TableText>계정 상태</TableText>
                  </Th>
                </Tr>
              </thead>
              <tbody>
                {memberList.length > 0 ? (
                  memberList.map((member) => (
                    <Tr key={member.id} style={{ height: "59px" }}>
                      <Td style={{ paddingLeft: "20px" }}>
                        <Checkbox
                          checked={selectedMemberIds.includes(member.id)}
                          onChange={() => toggleMember(member.id)}
                        />
                      </Td>
                      <Td>
                        <TableText>{member.account}</TableText>
                      </Td>
                      <Td>
                        <TableText>{member.name}</TableText>
                      </Td>
                      <Td>
                        <TableText>
                          {member.membership ? "구독회원" : "일반회원"}
                        </TableText>
                      </Td>
                      <Td>
                        <TableText>
                          {member.activation ? "활성" : "비활성"}
                        </TableText>
                      </Td>
                    </Tr>
                  ))
                ) : (
                  <Tr style={{ height: "80px" }}>
                    <Td colSpan={5} style={{ textAlign: "center" }}>
                      <TableText>검색된 회원이 없습니다.</TableText>
                    </Td>
                  </Tr>
                )}
              </tbody>
            </Table>
            <Pagination
              style={{ width: "100%" }}
              route={route.payment_coupon_issuance}
              queryString={`keyword=${encodeURIComponent(searchParams.get("keyword") || "")}`}
              currentPage={page}
              totalPages={pagination.totalPages}
              rangeSize={pagination.rangeSize}
            />
            <div
              style={{
                marginTop: 30,
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <SaveBtn
                style={{ position: "static" }}
                text={`선택 회원 ${selectedMemberIds.length}명에게 발급`}
                onClick={saveBtnHandler}
              />
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {saveModalOpen ? (
        <Modal
          title={modalMsg.update.title}
          text={modalMsg.update.content}
          setModalOpen={setSaveModalOpen}
          onClick={() => {
            saveFunc();
          }}
        />
      ) : null}
    </>
  );
};

export default CouponIssuance;

const QuestionWrapper = styled.div`
  position: relative;
  display: inline-block;

  &:hover .question-box {
    visibility: visible;
    opacity: 1;
  }
`;

const QuestionBox = styled.div`
  padding: 10px 20px;
  border: 1px solid #dfe1e4;
  border-radius: 12px;
  box-shadow: 0px 4px 25px 0px #00000026;
  background-color: #fff;
  position: absolute;
  right: 0;
  bottom: 30px;
  width: max-content;
  visibility: hidden;
  opacity: 0;
  transition:
    visibility 0.3s ease,
    opacity 0.3s ease;
`;
